/* PrepaidTieWarning.jsx -- Step 9's prepaid opening-balance WARNING (Batch 1b, 2026-11-03, N-d2; diffs/pantryproof-golive-check.txt
 * 5(f) 3). It does NOT re-derive anything: it mounts a ModelProvider for the wizard's company (AdminPage sits outside one -- the
 * GoLivePanel / Health Check pattern) and READS the engine's own tie verdict, runFullModel's prepaidTies (the saved opening balance
 * rolled through the stored contracts to the close, vs the close-month prepaid on the balance sheet, $5 tolerance) -- the same verdict
 * the Vendor Dashboard's Prepaid tab shows. It warns only when the close-month prepaid is nonzero and the roll does not reach it. A
 * warning, never a block: the forecast prepaid is re-seated from the close-month balance either way. The caller keys it on the saved
 * opening balance, so a "Use this value" save re-checks. Plain ASCII (CLAUDE.md 12.5 rule 55). */
import React from 'react';
import ModelProvider, { useModel } from '../ModelProvider';

export const PREPAID_TIE_WARNING = 'The prepaid schedule does not reach your opening prepaid balance — enter the contracts with their payment month, or set the opening balance by hand.';

/* the decision, pure (the engine computed both inputs): warn when the close-month prepaid is nonzero and the roll does not tie */
export const prepaidTieWarns = (prepaidTies, prepaidAnchor2) => prepaidTies === false && Number(prepaidAnchor2 || 0) !== 0;

function Inner() {
    const { rawData, loading, initialized } = useModel();
    if (loading || !initialized) return <div data-prepaid-tie-checking="" style={{ marginTop: 6, fontSize: 11, color: '#999' }}>Checking the prepaid schedule against your opening balance{'…'}</div>;
    if (!prepaidTieWarns(rawData?.prepaidTies, rawData?.prepaidAnchor2)) return null;
    return <div data-prepaid-tie-warning="" style={{ marginTop: 6, padding: '6px 10px', fontSize: 12, color: '#8C6500', background: '#FFF8E1', border: '1px solid #FFE0A0', borderRadius: 6 }}>
        {'⚠ ' + PREPAID_TIE_WARNING}
    </div>;
}

export default function PrepaidTieWarning({ companyId, companyName, runKey }) {
    return <ModelProvider companyId={companyId} companyName={companyName} key={companyId + ':' + runKey}><Inner /></ModelProvider>;
}
